import React from "react";
import { Link, useLocation } from "react-router-dom";
import Button from "../ui/Button";

const Footer = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const menuLinks = [
    { text: "Home", href: "/" },
    { text: "About Us", href: "/about" },
    { text: "Biospecimens", href: "/biospecimens-services" },
    { text: "Biostorage", href: "/biostorage" },
  ];

  const contactInfo = [
    {
      text: "info@avinyaresearchlab.com",
      href: "mailto:info@avinyaresearchlab.com",
    },
    {
      text: "https://avinyaresearchlab.com/",
      href: "https://avinyaresearchlab.com/",
    },
    { text: "+91 92747 92400", href: "tel:+919274792400" },
    {
      text: "4th Floor, C/o Priya Hospital, Behind Crecent Hotel, Lambhvel Road, Anand – 388 001, Gujarat, India",
      href: "https://www.google.com/maps/search/?api=1&query=Avinya+Research+Lab+Anand",
    },
  ];

  const socialLinks = [
    { src: "/images/img_group.svg", alt: "Facebook", href: "#" },
    { src: "/images/img_vector_indigo_900.svg", alt: "Twitter", href: "#" },
    { src: "/images/img_10_linkedin.svg", alt: "LinkedIn", href: "#" },
  ];

  return (
    <footer className="w-full bg-secondary-background 2xl:my-[80px] text-[#183076]">
      <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="px-4 sm:px-8 2xl:px-[130px] py-8 lg:py-0">
          {/* Footer Content */}
          <div className="flex flex-col lg:flex-row justify-between items-start gap-8 2xl:gap-[50px] pt-8 lg:pt-16">
            {/* Company Info */}
            <div className="flex flex-col gap-6 lg:gap-[26px] w-full lg:w-[28%]">
              <Link to="/" className="w-full max-w-[150px] lg:max-w-[256px]">
                <img
                  src="/images/img_group_73.svg"
                  alt="ANVIYA Research Lab Logo"
                  className="w-full h-auto object-contain"
                />
              </Link>

              <p
                className="text-[16px] md:text-[18px] 2xl:text-[24px] font-normal leading-lg text-primary-background text-justify"
                style={{ fontFamily: "Bricolage Grotesque" }}
              >
                {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. */}
              </p>
              <div>
                <Button
                  text="Book Now"
                  text_font_size="text-sm"
                  text_font_family="Bricolage Grotesque"
                  text_font_weight="font-bold"
                  fill_background_color="bg-transparent"
                  border_border_radius="rounded-full"
                  border_border="1px solid #183076"
                  className="mt-[20px]  border border-[#183076] text-[#183076] hover:bg-[#183076] hover:text-white transition-all rounded-full"
                  variant="outlined"
                  to="/form"
                />
              </div>
            </div>

            {/* Menu Links */}
            <div className="flex flex-col gap-3 lg:gap-[14px] w-full lg:w-[10%]">
              <h3
                className="text-[24px] 2xl:text-[30px] font-bold leading-lg text-primary-background mb-2"
                style={{ fontFamily: "Bricolage Grotesque" }}
              >
                Menu
              </h3>
              <nav className="flex flex-col gap-3 lg:gap-[12px]">
                {menuLinks?.map((link, index) => {
                  const isActive = currentPath === link.href;
                  return (
                    <span
                      key={index}
                      className={`text-[16px] md:text-[18px] 2xl:text-[24px] font-normal leading-sm cursor-default transition-colors ${
                        isActive
                          ? "text-[#183076] font-bold"
                          : "text-primary-background opacity-70"
                      }`}
                      style={{ fontFamily: "Bricolage Grotesque" }}
                    >
                      {link?.text}
                    </span>
                  );
                })}
              </nav>
            </div>

            {/* Contact Info */}
            <div className="flex flex-col gap-4 lg:gap-[16px] w-full lg:w-[22%]">
              <h3
                className="text-[24px] 2xl:text-[30px] font-bold leading-lg text-primary-background mb-2"
                style={{ fontFamily: "Bricolage Grotesque" }}
              >
                Info
              </h3>
              <div className="flex flex-col gap-3 lg:gap-[12px]">
                {contactInfo.map((info, index) => (
                  <span
                    key={index}
                    className="text-[16px] md:text-[18px] 2xl:text-[24px] font-normal leading-sm text-primary-background cursor-default"
                    style={{ fontFamily: "Bricolage Grotesque" }}
                  >
                    {info.text}
                  </span>
                ))}
              </div>
            </div>

            {/* Social Media */}
            <div className="flex flex-col gap-2 lg:gap-[10px] items-center w-full lg:w-auto">
              <h3
                className="text-[24px] 2xl:text-[30px] font-bold leading-lg text-primary-background mb-2"
                style={{ fontFamily: "Bricolage Grotesque" }}
              >
                Follow Us
              </h3>
              <div className="flex flex-row gap-2 lg:gap-[10px] justify-center items-center">
                {socialLinks?.map((social, index) => (
                  <div
                    key={index}
                    className="w-[40px] h-[40px] opacity-60 cursor-default"
                  >
                    <img
                      src={social?.src}
                      alt={social?.alt}
                      className="w-full h-full object-contain"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-11 m-auto mt-4 flex-warp gap-md-0 gap-sm-0 gap-4  row">
            <div
              className="col-md-6 col-12 text-start flex items-center justify-end gap-2 "
              style={{ color: "#183076" }}
            >
              Developed by : hi-lab solution
              <div className="cursor-default">
                <img
                  src="https://hi-labsolution.com/hlogo.png"
                  alt="Hi-Lab Solution"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
